import React from 'react';
import { FlaskConical, Stethoscope, Handshake, Truck, ShieldCheck, LineChart } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';
import Reveal from '@/components/Reveal';

const ICONS = [FlaskConical, Stethoscope, Handshake, Truck, ShieldCheck, LineChart];

export default function Services() {
  const { t } = useLang();
  return (
    <div data-testid="services-page">
      <section className="mm-section" style={{ paddingTop: 72 }}>
        <div className="container-mm">
          <div className="eyebrow">{t.home.services_eyebrow}</div>
          <h1 style={{ fontSize: 'clamp(48px, 6vw, 96px)', marginTop: 16 }}>{t.home.services_title}</h1>
          <p style={{ fontSize: 18, color: 'var(--mm-slate)', marginTop: 24, maxWidth: 720 }}>
            {t.home.services_lead}
          </p>

          <div className="mm-features" style={{ marginTop: 56 }}>
            {t.services.map((s, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <Reveal key={i} delay={i * 60} className="mm-col third">
                  <div className="mm-feature" style={{ height: '100%' }} data-testid={`service-${i}`}>
                    <div className="icon-wrap"><Icon size={20} /></div>
                    <h3>{s.t}</h3>
                    <p>{s.d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
